import { ChangeEvent, useContext } from 'react';
import * as R from 'ramda';

import { usePreferences } from '@atom/hooks/usePreferences';
import { Select } from '@atom/mui';
import { GrantType } from '@atom/types/policy';
import {
  getResourceOptions,
  SUB_SOURCE_LABEL,
} from '@atom/utilities/policyUtilities';

import PolicyModalContext from './PolicyModalContext';

const { MenuItem } = Select;

const PolicyGrantTypeSelection = () => {
  const { state, updateState } = useContext(PolicyModalContext);
  const { resource, grantType, loadingExistingPolicies } = state;

  const preferences = usePreferences();
  const resourceOptions = getResourceOptions(preferences);
  const showApprovalFlow: boolean = R.pathOr(
    false,
    ['budgeting', 'showApprovalFlow'],
    preferences,
  );

  const option = resourceOptions[resource];
  const menuItems = showApprovalFlow
    ? option.grantTypes
    : option.grantTypes.filter(type => type !== GrantType.BUDGETING_APPROVAL);

  return (
    <Select
      data-cy="roleDetailPolicySubSourceSelect"
      label="Sub Source"
      value={grantType || ''}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        updateState({ grantType: event.target.value as GrantType, grants: [] })
      }
      loading={loadingExistingPolicies}
      displayEmpty
    >
      {menuItems.map(type => (
        <MenuItem value={type} key={type}>
          {SUB_SOURCE_LABEL[type] || ''}
        </MenuItem>
      ))}
    </Select>
  );
};

export default PolicyGrantTypeSelection;
